import React from "react";

export const OnboardingContext = React.createContext({});

export const OnboardingProvider = OnboardingContext.Provider;
export const OnboardingConsumer = OnboardingContext.Consumer;
